import React, { Component } from 'react';
import ErrorMessage from '../common/ErrorMessage';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import poweredLogo from '../../img/powered-by-logo-v3.png';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import FormHelperText from '@material-ui/core/FormHelperText';
import { Checkbox } from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';


class Verify extends Component {
  renderResendCode() {
    const { handleResend } = this.props;
    return (
      <button onClick={handleResend} data-testid="verify-resend-code-button">
        Resend Code
      </button>
    );
  }


  render() {
    const {
      error,
      currentlySending,
      loading,
      mfacode,
      errorMFA,
      handleSubmit,
      handleMfaCodeChange,
      logo,
      contactText,
      mfaText,
      handleCheckBoxChangedEvent,      
      shouldDisplay,
      rememberMe
    } = this.props;

    return (
      <div className="d-flex justify-content-center flex-column align-items-center" data-testid="verify-page">
        <div className="col-xs-12 logo mt-4">
          <div className="box">{logo()}</div>
        </div>
        <div className="box">
          <Paper elevation={3} className="login-content-section">
            <form action="#" method="POST" onSubmit={handleSubmit}>
              <div className="row center-xs">
                <div className="col-sm-12">
                  <div className="box">
                    <h2 className="title mb-20">Enter Verification Code</h2>
                    <p className="sub-title mb-20">{mfaText}</p>
                  </div>
                </div>
                <div className="col-xs-12">
                  <div className="box">
                    {currentlySending || loading ? (
                      <div className="current-loading">
                        <div id="loadingIndicator" data-testid="verify-loading-indicator" className="loading-container position-relative h-100">
                          <div className="spinner-container">
                            <div className="spinner-0"></div>
                            <div className="spinner-1"></div>
                            <div className="spinner-2"></div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <ErrorMessage error={error} />
                    )}
                  </div>
                </div>
                <div className="col-sm-12">
                  <div className="box">
                    <FormControl fullWidth className="verify-input" error={errorMFA ? true : false} aria-describedby="mfa">
                      <InputLabel shrink className="los-input-label" htmlFor="mfa-label">
                        Verification Code
                      </InputLabel>
                      <Input
                        autoComplete="off"
                        id="mfa"
                        value={mfacode}
                        className={`${errorMFA ? 'invalid' : ''} los-input`}
                        onChange={handleMfaCodeChange}
                        inputProps={{ 'data-testid': 'verify-mfa-code-input' }}
                      />
                      <FormHelperText id="password-error-text" className="invalid-text">{errorMFA}</FormHelperText>
                    </FormControl>
                  </div>
                </div>
                <div className="col-xs-12">
                  <div className="box">
                    <FormControl className={`remember-checkbox align-items-center ${shouldDisplay ? 'd-flex' : 'd-none'}`}>
                      <FormControlLabel
                        control={<Checkbox id="rememberMe" disableRipple className={`los-v3-checkbox ${rememberMe ? 'ischecked' : ''}`}  checked={rememberMe} onChange={handleCheckBoxChangedEvent} />}
                        label="Remember me on this device."
                      />
                    </FormControl>
                  </div>
                </div>
                <div className="col-xs-12">
                  <div className="box">
                    <div />
                    <Button
                      variant="contained"
                      type="submit"
                      id="verify-button"
                      disableRipple
                      className="submitButton los-btn los-btn-primary shadow-none text-capitalize verify-btn"
                      color="primary"
                      disabled={currentlySending || loading ? true : false}
                      data-testid="verify-submit-button"
                    >
                      Verify
                    </Button>
                  </div>
                </div>
              
                <div className="col-xs-12">
                  <div className="box">
                    {contactText()}                   
                  </div>
                </div>
              </div>
            </form>
          </Paper>
          <a href="http://defisolutions.com" className="powered-img mb-5" target="_blank" rel="noopener noreferrer" data-testid="verify-powered-by-link">
            <img src={poweredLogo} alt="logo" />
          </a>
        </div>
      </div>
    );
  }
}

export default Verify;
